import { render } from "./Achievements.vue?vue&type=template&id=0aab2117"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"

import "./Achievements.vue?vue&type=style&index=0&id=0aab2117&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__